<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-md-3">
                        <b-form-input
                            v-model="filter"
                            class="form-control form-control-sm" 
                            type="search"
                            :placeholder="$t('label.search')"
                            v-on:change="searchListing"
                        ></b-form-input>
                    </div>
                    <div class="col-md-4"></div>
                    <div class="col-md-3">
                        <multiselect
                            v-model="isActive"
                            deselect-label="Can't remove this value"
                            track-by="value"
                            label="text"
                            :placeholder="$t('message.pleaseSelectX', [$t('module.status')])"
                            :options="statusDdl"
                            :searchable="true"
                            :allow-empty="false"
                            v-on:input="searchListing"
                        ></multiselect>
                    </div>
                    <div class="col-md-2">
                        <b-button class="btn-info col-12" v-b-modal.company-form>
                            {{ $t('label.createX', [$t('module.company')]) }}
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(isPrivate)="data">
                                    <span :class="`badge badge-pill badge-${data.item.isPrivate==1 ? 'info' : 'secondary'}`">
                                        {{ data.item.isPrivate==1 ? $t('label.yes') : $t('label.no') }}
                                    </span>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info"
                                        v-b-tooltip.hover
                                        :title="$t('label.updateX', [])"
                                        @click.stop="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>
									<a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
										:title="data.item.isActive==0?$t('label.restoreX', []):$t('label.deleteX', [])"
                                        v-on:click="deleteConfirmation(data.item)"
                                    >
										<i :class="[`mdi font-size-18 mdi-delete-${data.item.isActive==0?'restore':'outline'}`]"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="totalPage"
                                            :per-page="perPage"
                                            v-on:change="pageNavigation"
											variant="info"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="company-form"
            :title="$t(company.id ? 'label.updateX' : 'label.createX', [$t('module.company')])"
            @hidden="resetForm"
            size="lg"
            hide-header-close
            hide-footer
            centered
        >
            <template #default>
                <b-container fluid>
                    <div class="row">
                        <div class="col-md-12">
                            <b-tabs v-if="company.id" pills justified content-class="text-muted" active-nav-item-class="bg-info text-white">
                                <b-tab active class="border-0">
                                    <template v-slot:title>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="fas fa-city"></i>
                                        </span>
                                        <span class="d-none d-sm-inline-block">{{ $t('module.company') }}</span>
                                    </template>
                                    <CompanyForm
                                        class="mt-3"
                                        :companyID="company.id"
                                        :searchCriteria="searchCriteria"
                                        @done="closeForm"
                                        ref="companyForm"
                                    />
                                </b-tab>
                                <b-tab class="border-0">
                                    <template v-slot:title>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="fas fa-sitemap"></i>
                                        </span>
                                        <span class="d-none d-sm-inline-block">{{ $t('module.group') }}</span>
                                    </template>
                                    <GroupForm
                                        class="mt-3"
                                        :groupID="groupID"
                                        @done="closeForm"
                                        ref="groupForm"
                                    />
                                </b-tab>
                            </b-tabs>
                            <CompanyForm
                                v-else
                                class="mt-3"
                                :companyID="company.id"
                                :searchCriteria="searchCriteria"
                                @done="closeForm"
                                ref="companyForm"
                            />
                        </div>
                    </div>
                </b-container>
            </template>
        </b-modal>
        <b-modal
            id="company-delete"
            :title="company.isActive==0 ? $t('label.restoreX', [$t('module.department')]) : $t('label.deleteX', [$t('module.company')])"
            @hidden="resetForm"
            hide-header-close
        >
            <p class="my-4">{{ company.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" @click="$bvModal.hide('company-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2"
                    v-on:click="requestDelete"
                    :disabled="!status.save"
                >
                    {{ company.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
    </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { lookupMethods, companyMethods } from "@/state/helpers";
import { mapState } from "vuex";
import { COMPANY_MODULE } from '@/state/modules/company';
import { GLOBAL_FILTER_MODULE } from '@/state/modules/globalFilter';
import Multiselect from "vue-multiselect";
import CompanyForm from "@/views/pages/company/components/companyForm";
import GroupForm from "@/views/pages/group/components/groupForm";

export default {
    page: {
        title: i18n.t("label.listingX", [i18n.t('module.company')]),
    },
    beforeRouteLeave(to, from, next) {
        sessionHelper.clearSearch(SESSION.COMPANY_SEARCH);
        next();
    },
    components: { Layout, PageHeader, Multiselect, CompanyForm, GroupForm },
    async created() {
        sessionHelper.clearSearch(SESSION.COMPANY_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();
    },
    data() {
        return {
            title: i18n.t("label.listingX", [i18n.t('module.company')]),
            items: [
                {
                    text: i18n.t("module.company"),
                    href: "/company",
                },
                {
                    text: i18n.t("module.company"),
                    active: true,
                },
            ],
            filter: "",
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            fields: [
                { key: 'name', label: i18n.t("label.name"), sortable: true },
                { key: 'displayName', label: i18n.t("label.displayName"), sortable: true },
                { key: 'group', label: i18n.t("module.group"), sortable: true },
                { key: 'isPrivate', label: i18n.t("label.visibleToEveryone"), sortable: true },
                { key: 'budget', label: i18n.t("label.budget"), sortable: true },
                { key: 'costing', label: i18n.t("label.costing"), sortable: true },
                { key: 'actions', label: i18n.t("label.action"), sortable: false },
            ],
            company: {
                id: "",
                isActive: "",
            },
            groupID: "",
        };
    },
    methods: {
        ...companyMethods,
        ...lookupMethods,
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.COMPANY_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.COMPANY_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.isActive.value,
                    searchValue: "",
                    searchArray: [],
                };
            }
            if (sessionHelper.getCurrentGroup()) this.searchCriteria.group = JSON.parse(sessionHelper.getCurrentGroup())?.value; // filter based on group uuid
            this.getCompanyList(this.searchCriteria);
        },
        getCompanyList(filter) {
            this.getAllCompany({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.COMPANY_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.COMPANY_SEARCH);
            filter.pageNumber = pageNumber;
            this.getCompanyList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.isActive = this.isActive.value;
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getCompanyList(this.searchCriteria);
        },
        deleteConfirmation(company) {
            this.company = {
                id: company.id,
                isActive: company.isActive,
            };
            this.$bvModal.show('company-delete');
        },
        requestDelete() {
			let data = {
                id: this.company.id,
				isActive: this.company.isActive == 0 ? 1 : 0,
			}
			this.updateCompanyStatus({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('company-delete');
                }));
        },
        openForm(company) {
            if (company.id) {
                this.company = {
                    id: company.id,
                    isActive: company.isActive,
                };
                this.groupID = company.groupID?.value;
            }
            this.$bvModal.show('company-form');
        },
        closeForm() {
            this.$bvModal.hide('company-form');
        },
        resetForm() {
            this.company = {
                id: "",
                idActive: "",
            };
            this.$refs.companyForm?.resetForm();
            this.$refs.groupForm?.resetForm();
        },
    },
    computed: {
        ...mapState(COMPANY_MODULE, ['status']),
        ...mapState(GLOBAL_FILTER_MODULE, ['reload']),
        tableRows() {
            return this.$store.state.company.list.data || [];
        },
        totalPage() {
            return this.$store.state.company.list.pagination.total || 0;
        },
    },
    watch: {
        reload() {
            this.initSearchCriteria();
        },
    },
}
</script>